import {
  addQueryParameters,
  MILLISECONDS_IN_MONTH,
  MILLISECONDS_IN_SECOND,
} from '@seekingalpha/samw-utils';

import {
  ARTICLE,
  INSTABLOG,
  NEWS,
  PRESS_RELEASE,
  RESEARCH,
} from 'Constants/articleTypes';
import { VERY_BEARISH, BEARISH } from 'Constants/ratings';
import { getFullUrl } from 'Utils/getFullUrl';

import { MAX_GIFTS, NOT_SAVABLE_TYPES } from './constants';

import type { GiftArticleT } from './types';
import type { SavableArticleTypeT } from 'Services/api/savedArticles';
import type { ArticleTypeT } from 'Constants/articleTypes';
import type { GiftItemsT } from 'Services/api/giftLink/types';
import type { SentimentT } from 'Services/api/types';

type FilteredSentimentT = SentimentT & {
  tag?: {
    id: string;
    links: {
      self: string;
    };
    name: string;
    slug: string;
  };
};

const TODAY = new Date();

const SHORT_IDEAS_ALLOWED_SENTIMENTS_RATINGS = new Set([
  VERY_BEARISH.apiKey,
  BEARISH.apiKey,
]);

export const convertHeadlineType = (
  type: ArticleTypeT | undefined,
): SavableArticleTypeT => {
  switch (type) {
    case NEWS:
    case ARTICLE:
    case INSTABLOG:
    case PRESS_RELEASE: {
      return type;
    }
    case RESEARCH: {
      return INSTABLOG;
    }
    default: {
      return ARTICLE;
    }
  }
};

export const checkCanSave = (type: ArticleTypeT): boolean => {
  return !NOT_SAVABLE_TYPES.has(type);
};

export const getAvailableGiftTotal = (items?: GiftItemsT): number => {
  return items ? MAX_GIFTS - items.length : 0;
};

export const getSixMonthAgoSince = () => {
  return (TODAY.getTime() - 6 * MILLISECONDS_IN_MONTH) / MILLISECONDS_IN_SECOND;
};

export const filterSentiments = (
  sentiments: ReadonlyArray<FilteredSentimentT>,
): ReadonlyArray<FilteredSentimentT> => {
  // If an article contains two or more sentiments with different ratings, only display the ratings that are permitted for short ideas
  return sentiments.filter((item) => {
    return SHORT_IDEAS_ALLOWED_SENTIMENTS_RATINGS.has(item.type);
  });
};

export const generateGiftLink = (
  article: GiftArticleT,
  giftToken: string | null,
) => {
  if (giftToken) {
    const url = article.links.self.split('-')[0];

    return addQueryParameters(getFullUrl(url), {
      gt: giftToken,
    });
  }

  return null;
};
